import { Button } from "react-bootstrap";

const FilterHeading = ({
  onReset,
  onToggleVisibility,
  isFilterVisible,
  onExport,
  isExporting,
}) => {
  return (
    <div className="timesheet_filter_heading_block">
      <h5 className="timesheet_filter_heading">All Filters</h5>
      <div className="filterHeadingBtnBlock lastOne">
        {/* Export only renders when a handler is provided (optional, additive). */}
        {onExport && (
          <Button
            variant="outline-danger"
            onClick={onExport}
            disabled={isExporting}
          >
            {isExporting ? "Exporting..." : "Export"}
          </Button>
        )}
        <Button variant="outline-secondary" onClick={onToggleVisibility}>
          {isFilterVisible ? "Hide Filters" : "Show Filters"}
        </Button>
        <Button variant="outline-danger" onClick={onReset}>
          Reset Filter
        </Button>
      </div>
    </div>
  );
};

export default FilterHeading;
